import React, { useEffect, useState } from "react";
import { Button, Modal, Stack } from "react-bootstrap";
import styles from "./ModalComponent.module.scss";

const ModalComponent = ({
  action,
  actionHandler,
  handleClose,
  displayModal,
  modalTitle,
  modalBody,
  size = 500,
}) => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    setShow(displayModal);
  }, [displayModal]);

  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        centered={true}
        className={styles.modal}
        style={{
          ["--modal-size" as any]: `${size}px`,
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>{modalTitle}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{modalBody}</Modal.Body>
        <Modal.Footer>
          <Stack direction="horizontal" gap={4}>
            <Button variant="secondary" onClick={handleClose}>
              Cancel
            </Button>
            <Button
              variant="primary"
              onClick={() => {
                actionHandler(action);
              }}
            >
              {action}
            </Button>
          </Stack>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ModalComponent;
